import React from 'react';

interface TourStepProps {
  title: string;
  content: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrev: () => void;
  onSkip: () => void;
}

export const TourStep: React.FC<TourStepProps> = ({ title, content, currentStep, totalSteps, onNext, onPrev, onSkip }) => {
  return (
    <div className="relative pointer-events-auto bg-surface-container-highest p-6 rounded-xl shadow-ambient max-w-sm border border-outline-variant/20 z-[60]">
      <div className="absolute -top-3 left-6 w-0 h-0 border-l-[12px] border-l-transparent border-r-[12px] border-r-transparent border-b-[12px] border-b-surface-container-highest" />
      
      <h3 className="font-headline text-lg mb-2 text-on-surface">{title}</h3>
      <p className="text-on-surface-variant text-sm mb-6 pb-4 border-b border-outline-variant/10">
        {content}
      </p>
      
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-1 text-xs text-on-surface-variant/70">
           <button className="hover:text-on-surface text-left" onClick={onSkip}>Pular Tour</button>
           <span>{currentStep + 1} de {totalSteps}</span>
        </div>
        
        <div className="flex gap-2">
           <button 
             className="px-3 py-1.5 text-sm bg-surface-bright rounded hover:bg-surface-container transition-colors disabled:opacity-50" 
             disabled={currentStep === 0} 
             onClick={onPrev}
           >
             Anterior
           </button>
           <button 
             className="px-3 py-1.5 text-sm bg-primary text-on-primary rounded hover:bg-primary/90 transition-colors" 
             onClick={onNext}
           >
             {currentStep >= totalSteps - 1 ? 'Concluir' : 'Próximo'}
           </button>
        </div>
      </div>
    </div>
  );
};
